import React from 'react';
import styled from 'styled-components';
import {
  instructionParagraphDown,
  instructionParagraphUp,
  instructionVersionsParagraphDelete, instructionWasEdited
} from '../actions/instuctionActions';
import StyledIcon from '../../components/common/StyledIcon';

const ManageSection = (Component) => {
  const CloseButton = styled.span`
  width: 24px;
  line-height: 30px;
  z-index: 200;
  display: block;
  float: right;
  cursor: pointer;
`;

  const handleDelete = (props) => {
    if(props && "dataIndex" in props && "versionIndex" in props) {
      props.dispatch(instructionVersionsParagraphDelete(props.versionIndex, props.dataIndex));
    } else {
      console.error("Bad props in object, you must put dataIndex and versionIndex");
    }
  }

  const handleUp = (props) => {
    if(props.dataIndex) { //is disabled for first element
      props.dispatch(instructionParagraphUp(props.dataIndex));
      props.dispatch(instructionWasEdited(true));
    }
  }

  const handleDown = (props) => {
    if(props && "versionIndex" in props && checkIsLastElement(props)) {
      props.dispatch(instructionParagraphDown(props.dataIndex));
      props.dispatch(instructionWasEdited(true));
    }
  }

  const checkIsLastElement = props => {
    if(props && "versionIndex" in props && "versions" in props) return props.versions[props.versionIndex].data.length - 1 > props.dataIndex;
    return false;
  }
  return (props) => (<div style={{border: '1px solid black'}}>
    {!props.disable && props.dataIndex &&(<CloseButton title={'UP section'} onClick={() => handleUp(props)}><StyledIcon glyph="arrow-up"/></CloseButton>)}
    {!props.disable && checkIsLastElement(props) && (<CloseButton title={"DOWN section"} onClick={() => handleDown(props)}><StyledIcon glyph="arrow-down" /></CloseButton>)}
    {!props.disable && (<CloseButton onClick={() => handleDelete(props)} title={"Delete section"}><StyledIcon glyph="trash" /></CloseButton>)}
    <Component {...props} />
  </div>)
}

export default ManageSection///connect(mapStateToProps)(ManageSection);
